module.exports = __webpack_public_path__ + "img/image12.affa8ed6.jpg";